export default {
  request: function (req, tokensStr) {
    const tokens = tokensStr.split('|');
    this.drivers.http.setHeaders.call(this, req, {
      Authorization: 'Bearer ' + (req.url !== 'o/auth/refresh' ? tokens[0] : tokens[1])
    });
  },
  response: function (res) {
    if (res.body.token && res.body.refresh_token) {
      return res.body.token + "|" + res.body.refresh_token;
    }
    return null
  }
};
